import React from 'react';

import AppButton from 'rebook/apps/base/components/AppButton';

import styles from './style.scss';


const BookRentAppButtons = ({ isAudio }) => {
  const text = isAudio
    ? (
      <span>
        Аудиокниги можно слушать только в наших удобных <br className={styles.textWrapMiddle} />
        приложениях, <br className={styles.textWrapLarge} />онлайн и офлайн.
      </span>
    )
    : (
      <span>
        Рекомендуем вам читать в нашем удобном <br className={styles.textWrapMiddle} />
        приложении под своей учеткой!
      </span>
    );

  return (
    <div className={styles.mobileAppsTitleContainer}>
      <div className={styles.mobileAppsInfo}>
        {text}
      </div>
      <div className={styles.mobileButtons}>
        <AppButton showText target={`rent_purchase`} suppressHydrationWarning />
      </div>
    </div>
  );
};

export default BookRentAppButtons;
